import { motion } from "framer-motion";
import { images } from "../../utils/images";
import { useEffect, useState } from "react";
import { useContext } from 'react'
import { AppState } from '../../App'
import { useWeb3 } from '../../contexts/Web3Context'

const Header = () => {
  const useAppState = useContext(AppState);
  const { isWalletConnected , isContractReady} = useWeb3();
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    if (isContractReady && isWalletConnected) {
      setIsLoggedIn(true);
    }
  }, [isContractReady, isWalletConnected]);

  return (
    <div className="bg-dark text-white py-20 lg:py-32">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="grid lg:grid-cols-2 gap-12 items-center"
        >
          <div>
            <h1 className="text-4xl lg:text-6xl font-bold mb-6">
              Building Dreams <span className="text-primary">Together.</span>
            </h1>
            <p className="text-gray-300 text-lg mb-8">
              Mo<span className="text-primary">bnb</span> is a pioneering Web 3.0 platform powered by blockchain and
              smart contracts, designed to empower users on their journey
              towards economic independence and progressive lifestyles.
            </p>
            {isLoggedIn ? (
              <button
                onClick={() => useAppState.navigate("/dashboard")}
                className="bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
              >
                Dashboard
              </button>
            ) : (
              <button
                onClick={() => useAppState.Login()}
                className="bg-primary text-white px-8 py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors"
              >
                Start Now
              </button>
            )}
          </div>
          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2 }}
            className="relative h-[400px] rounded-lg overflow-hidden"
          >
            <img
              src={images.hero}
              alt="Platform illustration"
              className="absolute inset-0 w-full h-full object-cover"
            />
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Header;
